import c from 'classnames';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import { Link } from 'react-router-dom';
import { GetDividendDetailQuery } from 'site/graphql';
import ArrowLeftIcon from '../../../../core/svg/arrow_left.svg';
import { numberFormatByValue } from '../const';

type IDividendDetailRatingProps = {
    dividend: GetDividendDetailQuery['dividend'];
} & WithStyles<typeof styles>;

const DividendDetailRating: React.FC<IDividendDetailRatingProps> = ({ dividend, classes }) => {
    const { price, target } = dividend;
    const percent = ((target - price) / price) * 100;
    const isGrowing = target > price;

    return (
        <div className={classes.root}>
            <table className={classes.table}>
                <tbody>
                    <tr>
                        <td className={classes.cellLabel}>
                            Текущая цена акции (<span className="ruble-icon">₽</span>)
                        </td>
                        <td colSpan={3}>{numberFormatByValue(price)}</td>
                    </tr>
                    <tr>
                        <td className={classes.cellLabel}>
                            Потенциальная стоимость акции (<span className="ruble-icon">₽</span>)
                        </td>
                        {target ? (
                            <>
                                <td className={c(classes.cellTarget, { [classes.cellTargetGrow]: isGrowing })}>
                                    {numberFormatByValue(target)}
                                </td>
                                <td>
                                    <ArrowLeftIcon className={c(classes.icon, { [classes.iconGrow]: isGrowing })} />
                                </td>
                                <td className={c(classes.cellTarget, { [classes.cellTargetGrow]: isGrowing })}>
                                    {percent.toFixed(2)} %
                                </td>
                            </>
                        ) : (
                            <td colSpan={3}>-</td>
                        )}
                    </tr>
                </tbody>
            </table>
            <div className={classes.disclaimer}>
                <p>
                    Подробнее об оценке стоимости акций читайте{' '}
                    <Link to="/articles/zatratnyi-podhod">в нашей статье</Link>
                </p>
                <p>
                    Оценка акций разработана совместно с <Link to="/page/conomy">Conomy</Link>
                </p>
            </div>
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        root: {
            fontSize: 14,
            lineHeight: 16 + 'px',

            [theme.breakpoints.up('sm')]: {
                display: 'flex',
                justifyContent: 'space-between',
            },
        },
        table: {
            borderCollapse: 'collapse',
            maxWidth: 600,

            '& tr': {
                borderBottom: '1px solid #E5E5E5',
            },

            '& td': {
                padding: '10px 5px',
            },
        },
        cellLabel: {
            color: '#808080',
            fontWeight: 'bold',
            width: 1 + '%',

            [theme.breakpoints.up('sm')]: {
                minWidth: 300,
            },
        },
        cellTarget: {
            color: theme.colors.accent,
        },
        cellTargetGrow: {
            color: theme.colors.green,
        },
        disclaimer: {
            '& p': {
                color: '#575756',
                marginBottom: 1 + 'rem',
            },
        },
        icon: {
            width: 15,
            height: 15,
            fill: '#D9D9D9',
            transform: 'rotate(-90deg)',
            verticalAlign: 'top',
            margin: '0 15px',
        },
        iconGrow: {
            transform: 'rotate(90deg)',
        },
    });

export default injectSheet(styles)(DividendDetailRating);
